var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHeartOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.325 3.2c3.065 0 5.475 2.488 5.475 5.627 0 1.119-.287 2.195-.853 3.283-1.021 1.963-2.364 3.392-6.669 7.431l-1.78 1.66-.546-.513-1.231-1.157c-4.285-4.012-5.637-5.448-6.661-7.407-.57-1.093-.86-2.174-.86-3.297C3.2 5.688 5.61 3.2 8.675 3.2c1.404 0 2.775.547 3.825 1.484 1.05-.937 2.422-1.484 3.825-1.484zm-3.14 15.173c4.144-3.888 5.442-5.269 6.343-7 .452-.87.672-1.697.672-2.546 0-2.267-1.705-4.027-3.875-4.027-1.214 0-2.415.583-3.208 1.544l-.618.747-.616-.748C11.09 5.383 9.889 4.8 8.675 4.8 6.505 4.8 4.8 6.56 4.8 8.827c0 .853.222 1.682.678 2.556.904 1.73 2.21 3.117 6.337 6.981l.687.646.683-.637z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartOff);
export default __webpack_public_path__ + "static/media/ic_heartOff.f92445341d93525575321525f7422321.svg";
export { ForwardRef as ReactComponent };